// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__hct5s","header":"ClearentDisclaimer_header__xPpmk","inner":"ClearentDisclaimer_inner__1xyS_"};